import React from 'react';

import LOGO_IMG from 'assets/logo/logo_loading.svg';
import './styles.scss';

export default function GlobalLoader() {
  return (
    <div className="global-loader">
      <img className="global-loader--logo" alt="sectrify_logo" src={LOGO_IMG} />
    </div>
  );
}
